import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { HttpResponse, Job } from "@/types";

export function useDuplicateJob() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({ jobId }: { jobId: string }) => {
      const path = `companies/${currentCompanyId}/jobs/${jobId}/duplicate`;
      const res = await httpClient.post<Job, HttpResponse<Job>>(path);

      return res.data;
    },
  });

  return mutation;
}
